import { useEffect, useRef, useState } from 'react'

/**
 * Плашка «Вы успешно прошли курс» на странице темы (карточка 133).
 *
 * Признак «курс пройден целиком» — статус назначения PASSED (он учитывает ВСЕ темы,
 * включая итоговый тест). Важно: число пройденных тем (passedThemesCount) итоговый
 * тест НЕ учитывает, поэтому по нему нельзя судить о завершении курса.
 *
 * Показываем плашку в момент, когда курс ВПЕРВЫЕ стал пройден, и ровно один раз.
 * Первое наблюдение статуса только запоминаем (не показываем), иначе плашка
 * всплывала бы при каждом заходе в уже пройденный курс.
 *
 * `isCoursePassed`: true/false — статус известен; undefined — данные ещё не пришли.
 */
export const useCourseCompletionModal = (
  isCoursePassed: boolean | undefined,
  isProgressFetching: boolean
) => {
  const [isVisible, setIsVisible] = useState(false)
  const shownRef = useRef(false)
  const prevPassedRef = useRef<boolean | null>(null)

  useEffect(() => {
    // Ждём устоявшиеся свежие данные, чтобы не поймать устаревший кадр (урок 131).
    if (isProgressFetching || isCoursePassed === undefined) {
      return
    }

    const prev = prevPassedRef.current
    prevPassedRef.current = isCoursePassed

    // Первое наблюдение только запоминаем (prev === null): не показываем при заходе
    // в уже пройденный курс. Показываем только на переходе «не пройден» -> «пройден».
    if (prev === false && isCoursePassed && !shownRef.current) {
      shownRef.current = true
      setIsVisible(true)
    }
  }, [isCoursePassed, isProgressFetching])

  const closeCourseCompletion = () => setIsVisible(false)

  return { isCourseCompletionVisible: isVisible, closeCourseCompletion }
}
